export const contentHasAuthType = require('./contentHasAuthType');
export const getAccessMethodFromAuthTypes = require('./getAccessMethodFromAuthTypes');
export const locationBlackedOutForContent = require('./locationBlackedOutForContent');
export const shallowCheckAuthentication = require('./shallowCheckAuthentication');



// WEBPACK FOOTER //
// ./app/lib/auth/index.js